import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { get } from '../lib/api';
import styles from './VerificationCoverageMap.module.css';

export default function VerificationCoverageMap({ location }) {
  const container = useRef(null), map = useRef(null), marker = useRef(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    const instance = L.map(container.current).setView([8.51433, 123.09492], 13);
    map.current = instance;
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(instance);
    get('/platform-map/verification-coverage').then(({ areas }) => {
      if (!active) return;
      const bounds = L.latLngBounds([]);
      areas.forEach(area => {
        const options = { color: '#93c5fd', weight: 1, fillColor: '#60a5fa', fillOpacity: 0.15, interactive: false };
        const shape = area.geometry?.type === 'Polygon'
          ? L.polygon(area.geometry.coordinates[0].map(([lng, lat]) => [lat, lng]), options)
          : L.circle([area.location.coordinates[1], area.location.coordinates[0]], { ...options, radius: area.radiusMeters });
        shape.addTo(instance);
        bounds.extend(shape.getBounds());
      });
      if (!marker.current && bounds.isValid()) instance.fitBounds(bounds, { padding: [20, 20], maxZoom: 15 });
      if (!areas.length) setError('Account verification coverage has not been configured yet.');
    }).catch(() => { if (active) setError('Unable to load verification coverage. Reload to try again.'); });
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(() => instance.invalidateSize());
    observer?.observe(container.current);
    return () => { active = false; observer?.disconnect(); instance.remove(); map.current = null; marker.current = null; };
  }, []);
  useEffect(() => {
    marker.current?.remove(); marker.current = null;
    if (!location || !map.current) return;
    const [lng, lat] = location.coordinates;
    marker.current = L.circleMarker([lat, lng], { radius: 6, color: '#1d4ed8', fillOpacity: 1 }).addTo(map.current);
    marker.current.bindTooltip('Your GPS location');
    map.current.panTo([lat, lng]);
  }, [location]);
  return <div className="space-y-2">
    <p className="m-0 text-sm font-medium text-slate-700">Light blue areas show where account verification is available. Use GPS to check your current location.</p>
    <div ref={container} aria-label="Account verification coverage map" className={`${styles.map} overflow-hidden rounded-xl border`} style={{ height: 280, position: 'relative', zIndex: 0 }} />
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
  </div>;
}
